import React, { Component } from 'react';
import {
  FormControl, 
  InputLabel,
  Select, 
  MenuItem,
} from "@mui/material";

import { 
  SummonOption2 
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

type Props = {
  options: SummonOption2[];
  value: string | null;
  name: string;
  onChange: (value: string) => void;
  labelWidth: number | null;
  color: string;
  disabled: boolean;
}

export interface State { 
  labelWidth: number;
}

const char_util = DandDCharacterUtilities.getInstance();

class SelectSummonOption2Box extends Component<Props, State> {
  public static defaultProps = {
    labelWidth: null,
    value: null,
    color: "",
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      labelWidth: this.getLabelWidth(props.name)
    };
  }

  componentDidMount() {
  }

  getLabelWidth(name: string) {
    const smallCount = 
      this.countOccurences(name, "i") +
      this.countOccurences(name, "l") +
      this.countOccurences(name, "I") +
      this.countOccurences(name, "t") +
      this.countOccurences(name, "r") +
      this.countOccurences(name, " ");

    return ((name.length - smallCount) * 10 + smallCount * 4);
  }

  countOccurences(searchMe: string, findMe: string) {
    return searchMe.split(findMe).length - 1;
  }

  render() {
    if (this.props.color !== "") {
      return (
        <div style={{
          border: "1px solid #1C9AEF"
        }}>
          { this.renderControl() }
        </div>
      );
    } else {
      return this.renderControl();
    }
  }

  renderControl() {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel htmlFor={`selectInput_${this.props.name}`}>{this.props.name}</InputLabel>
        <Select
          labelId={`selectInput_${this.props.name}`}
          id={`selectInput_${this.props.name}`}
          value={this.props.value ? this.props.value : ""}
          onChange={(event: any) => {
            this.props.onChange(event.target.value);
          }}
          fullWidth
          disabled={this.props.disabled}
          // labelWidth={ this.props.labelWidth ? this.props.labelWidth : this.state.labelWidth }
        >
          { this.props.options.map((opt: SummonOption2, i: any) => {
            return (<MenuItem key={i} value={opt._id}>{opt.name}{ char_util.renderChallengeRating(opt.challenge_rating) }{ opt.count > 1 ? ` x ${opt.count}` : "" }</MenuItem>);
          })}
        </Select>
      </FormControl>
    );
  }
}

export default SelectSummonOption2Box;
